import React, { useEffect, useState } from 'react';
import { Virtual, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { getCustomer, imgBaseUrl } from '../../utils/api';
import Slider from "react-slick";

export default function BlogsSlider({categories}) {
//   const [customers, setCustomers] = useState([]);

  // Fetch customer data
//   useEffect(() => {
//     const fetchCustomer = async () => {
//       try {
//         const pay = { pageSize: 0, pageIndex: 0 };
//         const res = await getCustomer(pay);
//         setCustomers(res.data.data.items);
//       } catch (error) {
//         console.error('Error fetching customers:', error);
//       }
//     };
//     fetchCustomer();
//   }, []);
  const settings = {
    rtl: true,
    infinite: categories.length > 1, // فقط وقتی محصولات بیشتر از 4 تا باشند، اسلایدر حلقه‌ای می‌شود
    arrows: false,
    autoplay: true, // فقط وقتی محصولات بیشتر از 4 تا باشند، اسلاید خودکار فعال می‌شود
    autoplaySpeed: 3000,
    responsive: [
  
      {
        breakpoint: 900,
        settings: {
          slidesToShow:3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true, // اضافه کردن autoplay در اینجا
          autoplaySpeed: 3000,
        },
      },
    ],
  };
  return (

    <>
      <Slider {...settings} adaptiveHeight={true}>
        {categories.map((item, index) => (
           <div key={index} className="button-item first-group mb-2">
           <button className='btn d-flex align-items-center gap-2'>
             <img src={imgBaseUrl + item.logoPath} alt="" width={24} />
             <h6 className='flex-1'>{item.title}</h6>
           </button>
         </div>
        ))
        }
      </Slider>

    </>

  );
}
